import { useRef } from "react";
import SETTINGS from "../../settings";

import { OrbitControls } from "drei";

import log from "loglevel";

const CameraControls = (props) => {
  return (
    <OrbitControls
      autoRotate={false}
      autoRotateSpeed={1.0}
      enableZoom={true}
      minDistance={(props.size * 0.01) / SETTINGS.TERRAIN.SCALE}
      maxDistance={(props.size * 10) / SETTINGS.TERRAIN.SCALE}
      enablePan={true}
      minPolarAngle={(Math.PI / 180) * 0} //Plan (in perspecive)
      maxPolarAngle={(Math.PI / 180) * 90} //Elevation (in perspecive)
      enableDamping={true}
      dampingFactor={0.3}
    />
  );
};

export default CameraControls;
